import React from "react";
import { formatMoney } from "utilities/formatter";

interface Props {
  value: string
  // The serialized money from the server, it holds the currency
  serverValue: string
}

const ReadonlyMoney = ({ value, serverValue }: Props) => {
  const money: server.dto.Money = JSON.parse(serverValue);
  const formatted = formatMoney({ value: Number.parseFloat(value), currency: money.currency, displayCents: true });

  return <>{formatted}</>;
};

export default ReadonlyMoney;
